import React from 'react';
import WarningActionDialog from './WarningActionDialog';
import { BarcodeMismatchItem } from '../EcwConstants';

interface BarcodeMismatchWarningDialogProps {
    show: boolean;
    mismatches: BarcodeMismatchItem[];
    onAccept: () => void;
    onCancel: () => void;
}

const BarcodeMismatchWarningDialog: React.FC<BarcodeMismatchWarningDialogProps> = ({
    show,
    mismatches,
    onAccept,
    onCancel,
}) => {
    return (
        <WarningActionDialog
            id="BarcodeMismatchWarningModal"
            show={show}
            title="Warning"
            message="The scanned item details do not match the selected order values. Do you want to continue?"
            onAccept={onAccept}
            onCancel={onCancel}
        >
            <div className="mismatch-list">
                {mismatches.map((item, index) => (
                    <div key={index} className="mismatch-item">
                        <div className="mismatch-field-title">
                            {item.field}
                        </div>
                        <div className="mismatch-columns">
                            <div className="mismatch-col">
                                <span className="col-label">Ordered</span>
                                <strong className="col-value ordered">{item.orderValue}</strong>
                            </div>
                            <div className="mismatch-col">
                                <span className="col-label">Scanned</span>
                                <strong className="col-value scanned">{item.barcodeValue}</strong>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </WarningActionDialog>
    );
};

export default BarcodeMismatchWarningDialog;
